import { render } from "./CreateUserSimpleDialog.vue?vue&type=template&id=6f857d97"
import script from "./CreateUserSimpleDialog.vue?vue&type=script&lang=js"
export * from "./CreateUserSimpleDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__